import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { ModesRequest } from "interfaces/requests/Modes";

const BASE_URL = "/matches";

export const panicMode = createAsyncThunk(
  "matches/panicMode",
  async (request: ModesRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/panicMode`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - panic mode ->", error);
      throw new Error(error.message);
    }
  },
);

export const resetMode = createAsyncThunk(
  "matches/resetMode",
  async (request: ModesRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/resetMode`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - reset mode ->", error);
      throw new Error(error.message);
    }
  },
);
